import { render, staticRenderFns } from "./batchPaymentRecord.vue?vue&type=template&id=ad9d2a50&scoped=true"
import script from "./batchPaymentRecord.vue?vue&type=script&lang=js"
export * from "./batchPaymentRecord.vue?vue&type=script&lang=js"
import style0 from "./batchPaymentRecord.vue?vue&type=style&index=0&id=ad9d2a50&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9d2a50",
  null
  
)

export default component.exports